export default "__VITE_ASSET__CjschDmD__"